"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";

export default function GreekNotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-ui-page px-4">
      <div className="flex flex-col items-center gap-6 text-center">
        <h1 className="text-6xl font-bold text-brand-text">404</h1>
        <p className="text-lg text-brand-text">
          {t("The page you are looking for could not be found.")}
        </p>
        <Link href="/" className="primary-button text-ui-card">
          {t("Go to Homepage")}
        </Link>
      </div>
    </div>
  );
}

